export enum AppInterfaceTheme {
  LIGHT = "light",
  DARK = "dark",
}
